<div class="p-6">
  <div class="flex justify-between items-center mb-6">
    <h2 class="text-2xl font-semibold">Canal de Denuncias</h2>
    <button mat-raised-button color="primary" (click)="exportCsv()">
      <mat-icon>download</mat-icon> Exportar CSV
    </button>
  </div>

  <!-- Panel de métricas colapsable -->
  <app-denounce-metrics-panel></app-denounce-metrics-panel>

  <!-- Tabs -->
  <mat-tab-group (selectedTabChange)="onTabChange($event.index === 0 ? 'pending' : 'history')">
    <mat-tab label="Pendientes"></mat-tab>
    <mat-tab label="Historial"></mat-tab>
  </mat-tab-group>

  <!-- Barra de filtros -->
  <div class="filter-bar mt-4">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Buscar...</mat-label>
      <input matInput [(ngModel)]="searchText" (keyup.enter)="onSearch()" placeholder="ID, denunciado, descripción...">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <button mat-stroked-button
            class="filter-toggle"
            (click)="toggleAdvancedFilters()"
            [class.active]="showAdvancedFilters || hasActiveFilters()">
      <mat-icon>filter_list</mat-icon>
      Filtros
      <span class="filter-dot" *ngIf="hasActiveFilters()"></span>
    </button>

    <button mat-button *ngIf="hasActiveFilters()" (click)="clearFilters()">
      <mat-icon>clear</mat-icon> Limpiar
    </button>
  </div>

  <!-- Panel de filtros avanzados -->
  <div class="advanced-filters" *ngIf="showAdvancedFilters">
    <div class="filter-grid">
      <mat-form-field appearance="outline">
        <mat-label>Estado</mat-label>
        <mat-select [(value)]="filterStatus">
          <mat-option value="">Todos</mat-option>
          <mat-option value="RECIBIDA">Recibida</mat-option>
          <mat-option value="EN_INVESTIGACION">En investigación</mat-option>
          <mat-option value="CONCLUIDA">Concluida</mat-option>
          <mat-option value="DESESTIMADA">Desestimada</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Categoría</mat-label>
        <mat-select [(value)]="filterCategory">
          <mat-option value="">Todas</mat-option>
          <mat-option *ngFor="let c of categories" [value]="c.value">
            {{ c.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Responsable asignado</mat-label>
        <mat-select [(value)]="filterOperator">
          <mat-option value="">Todos</mat-option>
          <mat-option *ngFor="let op of operators" [value]="op.id">
            {{ op.operatorName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Desde</mat-label>
        <input matInput type="date" [(ngModel)]="filterDateFrom">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Hasta</mat-label>
        <input matInput type="date" [(ngModel)]="filterDateTo">
      </mat-form-field>

      <mat-checkbox [(ngModel)]="filterUnassignedOnly" color="primary" class="unassigned-check">
        Solo sin asignar
      </mat-checkbox>
    </div>

    <div class="flex justify-end gap-2 mt-2">
      <button mat-stroked-button (click)="clearFilters()">Limpiar</button>
      <button mat-flat-button color="primary" (click)="applyFilters()">Aplicar</button>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center py-8">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Table -->
  <div class="bg-white rounded-2xl shadow-md mt-4" *ngIf="!loading">
    <table mat-table [dataSource]="dataSource" class="w-full">

      <ng-container matColumnDef="trackingId">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let d" class="font-mono font-semibold cursor-pointer" (click)="goToDetail(d)">
          <div class="id-cell">
            <span class="id-text text-blue-600">{{ d.trackingId }}</span>
            <span *ngIf="isStale(d)" class="stale-badge" matTooltip="Sin asignar hace más de 7 días">
              <mat-icon>warning</mat-icon>
              {{ daysSinceCreated(d.createdAt) }}d
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef>Categoría</th>
        <td mat-cell *matCellDef="let d" class="category-cell">
          <span class="category-chip">{{ getCategoryLabel(d.category) }}</span>
          <span *ngIf="d.isAnonymous" class="anon-chip" matTooltip="Denuncia anónima">
            <mat-icon>visibility_off</mat-icon>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="relationship">
        <th mat-header-cell *matHeaderCellDef>Vínculo</th>
        <td mat-cell *matCellDef="let d">{{ d.relationship }}</td>
      </ng-container>

      <ng-container matColumnDef="accusedName">
        <th mat-header-cell *matHeaderCellDef>Denunciado</th>
        <td mat-cell *matCellDef="let d">{{ d.accusedName }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let d">
          <span class="px-2 py-1 rounded-full text-xs text-white font-medium"
                [style.background-color]="getStatusColor(d.status)">
            {{ getStatusLabel(d.status) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="assignedOperator">
        <th mat-header-cell *matHeaderCellDef>Responsable</th>
        <td mat-cell *matCellDef="let d">
          <span *ngIf="d.assignedOperator" class="px-2 py-1 rounded-full text-xs bg-green-100 text-green-800">
            {{ d.assignedOperator.operatorName }}
          </span>
          <span *ngIf="!d.assignedOperator"
                class="px-2 py-1 rounded-full text-xs"
                [class.bg-red-100]="isStale(d)"
                [class.text-red-700]="isStale(d)"
                [class.bg-orange-100]="!isStale(d)"
                [class.text-orange-800]="!isStale(d)">
            {{ isStale(d) ? 'Urgente · sin asignar' : 'No asignada' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>Fecha ingreso</th>
        <td mat-cell *matCellDef="let d">{{ d.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Acciones</th>
        <td mat-cell *matCellDef="let d">
          <button mat-icon-button color="primary" (click)="goToDetail(d)" matTooltip="Ver detalle">
            <mat-icon>visibility</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          class="hover:bg-gray-50 cursor-pointer"
          [class.stale-row]="isStale(row)"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center py-8" [attr.colspan]="displayedColumns.length">
          No hay denuncias que coincidan con los filtros
        </td>
      </tr>
    </table>

    <mat-paginator
      [length]="total"
      [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 20]"
      (page)="onPageChange($event)"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
